<script>
import { FallbackImageElementMixin } from "%/dynamic-components/render-engine/components/production/elements/image-element/fallback-image-element-mixin";
import BaseImageElement
  from "%/dynamic-components/render-engine/components/production/elements/image-element/BaseImageElement.vue";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import { mediaIdFromValue } from "%/lib/media-reference";
import { useMediaPlaybackStore } from "%/stores/media-playback-store";
import LinkToEntityPage from "%/dynamic-components/render-engine/options/link-to-entity-page";
import { resolveEntityPageUrl }
  from "@bloglovin/inspire-engine/DynamicComponents/Helpers/entity-page-links";

export default {
  name: "DynamicAppImageElement",
  extends: BaseImageElement,
  mixins: [FallbackImageElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "DynamicAppImageElement",
    elementGroup: "general",
    displayIcon: "image",
    elementType: "element",
  },
  hidden: true,
  options: [
    LinkToEntityPage,
  ],
  data() {
    return {
      resolvedMediaUrl: "",
    };
  },
  computed: {
    // The stored value is either a media_id (new) — resolved to a fresh URL
    // at render — or a legacy baked URL, used directly.
    imageSrc() {
      if (mediaIdFromValue(this.valueFromContext) !== null) {
        return this.resolvedMediaUrl;
      }
      return this.valueFromContext;
    },
    // "Link To Page": a thumbnail / cover image links to its bound entity's
    // display page (standard-image-element-mixin's imageHref prefers this
    // href when set). A null resolution renders unlinked.
    entityPageHref() {
      if (this.editMode || this.getOptionValue(LinkToEntityPage) !== true) {
        return null;
      }
      return resolveEntityPageUrl(
        this.entityType,
        this.contextItem.entityPkUrlVars,
        this.appName,
      );
    },
  },
  watch: {
    valueFromContext: {
      immediate: true,
      handler() {
        this.resolveMediaUrl();
      },
    },
  },
  methods: {
    resolveMediaUrl() {
      const mediaId = mediaIdFromValue(this.valueFromContext);
      if (mediaId === null) {
        this.resolvedMediaUrl = "";
        return;
      }
      useMediaPlaybackStore().resolveMediaPlayback(mediaId, data => {
        this.resolvedMediaUrl = data.url;
      });
    },
  },
};
</script>
